var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpectrocardMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 154,
    viewBox: "0 0 87 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9104",
    "data-name": "Rectangle 9104",
    width: 87,
    height: 154,
    transform: "translate(30 40)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 64.032,
    height: 40.006,
    rx: 4,
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 64.032,
    height: 40.006,
    rx: 4,
    fill: "#dceaef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9103",
    "data-name": "Rectangle 9103",
    width: 67.112,
    height: 43.053,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9102",
    "data-name": "Rectangle 9102",
    width: 67.112,
    height: 43.053,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6769",
    "data-name": "Mask Group 6769",
    transform: "translate(-30 -40)",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40199",
    "data-name": "Group 40199",
    transform: "translate(44.749 154.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M0,12.642l7.131-4.33V0L0,4.346Z",
    transform: "translate(7.132 4.214)",
    fill: "#fcea80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M7.131,12.642,0,8.312V0L7.131,4.346Z",
    transform: "translate(0 4.195)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M0,4.26,7.131,0l7.131,4.26L7.131,8.59Z",
    transform: "translate(0 0)",
    fill: "#fefefe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40200",
    "data-name": "Group 40200",
    transform: "translate(39.617 51.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36445",
    "data-name": "Path 36445",
    d: "M8.028,129.626.1,121.9l7.928,4.853Z",
    transform: "translate(-0.093 -114.193)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36446",
    "data-name": "Path 36446",
    d: "M125,129.6l7.905-7.73L125,126.717Z",
    transform: "translate(-117.097 -114.164)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36447",
    "data-name": "Path 36447",
    d: "M7.9,0,0,7.713l7.9,4.843Z",
    transform: "translate(0 0)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36448",
    "data-name": "Path 36448",
    d: "M125,0l7.9,7.713L125,12.556Z",
    transform: "translate(-117.097 0)",
    fill: "#fefefe"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40201",
    "data-name": "Group 40201",
    transform: "translate(93.94 74.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7-2",
    "data-name": "Fill 7",
    d: "M0,12.642l7.131-4.33V0L0,4.346Z",
    transform: "translate(7.131 4.214)",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8-2",
    "data-name": "Fill 8",
    d: "M7.131,12.642,0,8.312V0L7.131,4.346Z",
    transform: "translate(0 4.195)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9-2",
    "data-name": "Fill 9",
    d: "M0,4.26,7.131,0l7.131,4.26L7.131,8.59Z",
    transform: "translate(0)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40216",
    "data-name": "Group 40216",
    transform: "translate(-81.32 58.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40215",
    "data-name": "Group 40215",
    transform: "translate(111.321 31.924)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6767",
    "data-name": "Mask Group 6767",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 36.185, 8.526)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40205",
    "data-name": "Group 40205",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36449",
    "data-name": "Path 36449",
    d: "M0,0H64.032V40.006H0Z",
    transform: "translate(0)",
    fill: "#f8f8f8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6768",
    "data-name": "Mask Group 6768",
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 26.458, 4.092)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40209",
    "data-name": "Group 40209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36465",
    "data-name": "Path 36465",
    d: "M0,0H64.032V40.006H0Z",
    transform: "translate(0 0)",
    fill: "#dceaef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40214",
    "data-name": "Group 40214",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 11.143, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40213",
    "data-name": "Group 40213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40212",
    "data-name": "Group 40212",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5982",
    "data-name": "Group 5982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5981",
    "data-name": "Group 5981"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18333",
    "data-name": "Path 18333",
    d: "M0,0H67.112V43.053H0Z",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5977",
    "data-name": "Group 5977",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40211",
    "data-name": "Group 40211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40210",
    "data-name": "Group 40210",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5976",
    "data-name": "Group 5976",
    transform: "translate(-4.729 -27.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5975",
    "data-name": "Group 5975",
    transform: "translate(0 0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18334",
    "data-name": "Path 18334",
    d: "M25.884,90.191,0,45.1,25.884,0,51.768,45.1Z",
    transform: "translate(35.179)",
    fill: "#0b1622"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1245",
    "data-name": "Ellipse 1245",
    cx: 27.237,
    cy: 27.75,
    rx: 27.237,
    ry: 27.75,
    transform: "translate(0 39.811)",
    fill: "#fa9419",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18335",
    "data-name": "Path 18335",
    d: "M17.913,34.606a28.19,28.19,0,0,0,1.381-8.743A27.753,27.753,0,0,0,1.95,0L0,3.4Z",
    transform: "translate(35.179 41.698)",
    fill: "#fff"
  }))))))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24041",
    "data-name": "Path 24041",
    d: "M10.976.067,1.3,0A1.286,1.286,0,0,0,.043,1.31L0,7.456A1.286,1.286,0,0,0,1.243,8.783l9.671.068a1.286,1.286,0,0,0,1.26-1.31l.043-6.146A1.287,1.287,0,0,0,10.976.067Z",
    transform: "translate(4.784 15.175)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrocardMobile);
export default __webpack_public_path__ + "static/media/spectrocard_mobile.21d22bf465b65540cbbdf587ec8cf095.svg";
export { ForwardRef as ReactComponent };